import React, { ReactNode } from "react";
import { LeaderboardDto } from "../../../core/models/dtos/leaderboard.dto";
import FirebaseService from "../../../core/services/firebase.service";
import { Images } from "../../../core/utilities/images";
import "./UserData.scss";

interface IProps {
  leaderboard: LeaderboardDto;
  callbackCampaign: () => void;
}

const UserData = (props: IProps) => {
  const handleCampaignClick = (): void => {
    FirebaseService.logEvent(
      FirebaseService.user_count_kmb_home_campaign_click
    );
    props.callbackCampaign();
  };

  const renderRanking = (): ReactNode => {
    return (
      <div className="data-box ranking">
        <img className="bg" src={Images.user_rank} alt="rank" />
        <span className="title link-xsmall">Sıralamam</span>
        <span className="text display-small-bold">
          {props.leaderboard.rank}.
        </span>
      </div>
    );
  };

  const renderReward = (): ReactNode => {
    return (
      <div className="data-box reward">
        <img
          className="bg"
          src={Images.popup_header_icon_congrats}
          alt="reward"
        />
        <span className="title link-xsmall">Toplam Kazancım</span>
        <span className="text display-small-bold">
          {props.leaderboard.totalGain}
        </span>
        <span className="text-xxsmall note">
          <b>FREEBYTE</b>
        </span>
      </div>
    );
  };

  const renderCampaign = (): ReactNode => {
    return (
      <div className="campaign-box" onClick={() => handleCampaignClick()}>
        <img
          className="bg"
          src={Images.popup_header_bg_confetti}
          alt="campaign"
        />
        <img className="gift" src={Images.offer_icon_gift} alt="gift" />
        <span className="text link-small">20.000 FreeByte FIRSATI</span>
        <img className="button" src={Images.campaign_button} alt="button" />
      </div>
    );
  };

  return (
    <div id="user-data">
      <div className="mobile d-flex d-md-none">
        {renderRanking()}
        {renderReward()}
        {renderCampaign()}
      </div>

      <div className="desktop d-none d-md-flex flex-column justify-content-between">
        <div className="d-flex mb-3">
          {renderRanking()}
          {renderReward()}
        </div>
        <div className="d-flex">{renderCampaign()}</div>
      </div>
    </div>
  );
};

export default UserData;
